import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2'

import {
  NgForm,
} from '@angular/forms';
import { GetTitleService } from 'src/app/services/contacts/getTitle/get-title.service';
import { GetCountryStateCityService } from 'src/app/services/contacts/getCountryStateCity/get-country-state-city.service';
import { PinCodeToGetDetailsService } from 'src/app/services/contacts/pinCodeToGetDetails/pin-code-to-get-details.service';
import { GetAllLanguageService } from 'src/app/services/contacts/getAllLanguage/get-all-language.service';
import { GetAllEducationService } from 'src/app/services/contacts/getAllEducation/get-all-education.service';
import { GetPartnerIDService } from 'src/app/services/donation/getPartnerID/get-partner-id.service';
import { CreateNewpartnerIdService } from 'src/app/services/contacts/createNewpartnerId/create-newpartner-id.service';
import { LoginService } from 'src/app/services/auth/login/login.service';


declare var $: any
declare var app: any

@Component({
  selector: 'app-create-new-partner-idin-event',
  templateUrl: './create-new-partner-idin-event.component.html',
  styleUrls: ['./create-new-partner-idin-event.component.less']
})

export class CreateNewPartnerIDInEventComponent implements OnInit {

  @Output() createResponse = new EventEmitter<any>()
  @Output() createResponseModelReady = new EventEmitter<String>()
  @Output() createResponseAlreadyExist = new EventEmitter<any>()


  // config for monetary 
  public requiredField: Boolean = true

  @ViewChild("closeBtn", null)
  closeBtn: ElementRef;

  @ViewChild('createPartnerIdData', { static: false }) createPartnerIdData: NgForm;

  // selectDate: Date = new Date();

  options: DatepickerOptions = {
    minYear: 1930,
    maxYear: 2030,
    displayFormat: 'MMM - DD - YYYY',
    barTitleFormat: 'MMM - DD - YYYY',
    dayNamesFormat: '',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    // locale: frLocale,
    // minDate: new Date(Date.now()), // Minimal selectable date
    maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };

  /** 
   * create partner ID variables
   */
  public allTitle: any
  public allCSC: any
  public tempState: any
  public allState: any
  public allCity: any
  public allDistrict: any
  public countryID: any
  public stateID: any
  public cityID: any
  public province: Boolean = false
  public marital = {
    married: false
  }
  public denominationData: any = [
    "Roman Catholic",
    "Marthoma Church",
    "Jacobite Church",
    "CSI",
    "CNI",
    "Evangelical Church",
    "Lutheran Church",
    "Methodist Church",
    "Baptist Church",
    "Brethren Church",
    "Pentecostal Church",
    "Others",
  ]
  /**
 * no value in selection box
 */
  public noCountryAvailable: Boolean = true
  public noStateAvailable: Boolean = true
  public noCityAvailable: Boolean = true
  public noCityAvailableCancelButton: Boolean = true
  public noDistrictAvailable: Boolean = true



  public ifSelectedCountryIndia: Boolean
  public mobileNoValidation: Number = 20
  public mobileNoValidationMin: Number = 10

  /**
 * Validation variables
 */
  public invalidPin: Boolean = false
  public ifForeign: Boolean = true

  /** 
  * Loader variables
  */
  public skeleton: Boolean = true
  public pinCodeLoader: Boolean = false


  /**
 * Pin Code to Populate Auto Data
 */
  public pintoPopulate = {
    city: "", state: "", state_id: "", district: "", address3: ""
  }

  /**
   * main variables
   */
  public address1: any = ''
  public address2: any = ''
  public address3: any = ''

  /**
   *  button Loader
   */
  public submitLoading: Boolean = false

  /**
   * language and education
   */
  public allLanguage: any = []
  public allEduction: any = []

  minYearsAgo
  maxYearsAgo

  constructor(
    private GetTitleService: GetTitleService,
    private GetCountryStateCityService: GetCountryStateCityService,
    private PinCodeToGetDetailsService: PinCodeToGetDetailsService,
    private CreateNewpartnerIdService: CreateNewpartnerIdService,
    private GetAllLanguageService: GetAllLanguageService,
    private GetAllEducationService: GetAllEducationService,
    private GetPartnerIDService: GetPartnerIDService,
    private LoginService: LoginService,
    // private ServerStatusService: ServerStatusService
  ) {

    this.maxYearsAgo = moment().format("YYYY-MM-DD");
  }

  async ngOnInit() {
    await this.getTitle()

    let result = await this.getAllCSC()
    if (result.statusText == "Unknown Error" || result.statusCode == 500) {
      // this.ServerStatusService.notify(`SERVER-DOWN-CRITICAL check the logs and fix the issue [ Event Register API Error ] [ Get Title => API Error ]`)
      app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
    }
    await this.getLanguage()
    await this.getEduction()
    this.allCSC = result.data
    this.allCSC.push({ name: "Others" })
    setTimeout(() => {
      $(`.title`).selectpicker('refresh');
      $(`.language`).selectpicker('refresh');
      $(`.eduction`).selectpicker('refresh');
      $(`.denomination`).selectpicker('refresh');
      $(`.country`).selectpicker('refresh');
      $(`.state`).selectpicker('refresh');
      $(`.profession`).selectpicker('refresh');
      $(`.selectMinistry`).selectpicker('refresh');
      $("[data-id='State']").prop('disabled', true);
      $(`.city`).selectpicker('refresh');
      $("[data-id='City']").prop('disabled', true);
      $(`.district`).selectpicker('refresh');
      $("[data-id='District']").prop('disabled', true);
      this.createResponseModelReady.emit("ready")
    }, 100)
  }

  async createNewPartnerID(val) {
    let user_id = JSON.parse(localStorage.getItem("userDetails"))
    if (user_id == undefined || user_id == null) await this.LoginService.userLogOut()
    this.submitLoading = true
    let data = {
      "partnerId": val.partnerId,
      "full_name": val.fullName + " " + val.lastName,
      "title_id": val.title,
      "primary_mobile_no": val.mobileNumber,
      "email_id": val.email,
      "address_line1": val.address1,
      "address_line2": val.address2,
      "address_line3": this.ifForeign == true ? '' : val.address3 == "" ? val.district.split(',')[1] : val.address3 + ',' + val.district.split(',')[1],
      "postal_code": val.pinCode,
      "country_id": this.countryID,
      "state_id": this.stateID,
      "state_name": val.state == '' ? this.pintoPopulate.state : val.state,
      "country_name": val.country,
      "district": this.ifForeign == true ? null : val.district.split(',')[0],
      "city_id": this.cityID,
      "city": val.city,
      "dob": val.dob == "" ? null : moment(val.dob).format("YYYY-MM-DD"),
      "sex": val.gender == 1 ? 'Male' : 'female',
      "martial_status": val.maritalStatus == 1 ? 'Single' : val.maritalStatus == 2 ? 'Married' : 'Widowed',
      "education_id": val.eduction,
      "language_id": val.language.toString(),
      "occupation": "",//val.occupation,
      "wed_date": "",//val.anniversary == undefined ? null : val.anniversary == "" ? null : moment(val.anniversary).format("YYYY-MM-DD"),
      "alter_phone_no": null,
      "land_line_no": null,
      "province": this.province == false ? null : val.province == '' ? null : val.province,
      "born_agin_experience": val.experience == 1 ? true : false,
      "holy_spirit_baptism": null, //val.baptism == 1 ? true : false,
      "present_ministry": val.presentMinistry,
      "church_name": val.churchName,
      "pastor_address": "NA",
      "pastor_name": val.pastorName,
      "denomination": val.denomination,
      "user_id": parseInt(user_id.STAFF_ID),
      "profession": $('#Profession').val(),
      "aadhar_number": val.aadharNumber,
      "ministry_type": val.ministryType,
      "select_ministry": $(`#SelectMinistry`).val(),
      "ministry_name": val.ministryName
    }

    let result = await this.CreateNewpartnerIdService.createNew(data)
    if (result.status == "warning") {
      this.submitLoading = false
      Swal.fire(
        'warning!',
        'Partner id already exist...!',
        'warning'
      )
      return
    }
    if (result.status == "success") {
      this.submitLoading = false
      this.pintoPopulate.state = ""
      this.createPartnerIdData.resetForm();
      $(`.title`).selectpicker('refresh');
      $(`.language`).selectpicker('refresh');
      $(`.eduction`).selectpicker('refresh');
      $(`.country`).selectpicker('refresh');
      $(`.state`).selectpicker('refresh');
      $("[data-id='State']").prop('disabled', true);
      $(`.city`).selectpicker('refresh');
      $("[data-id='City']").prop('disabled', true);
      $(`.district`).selectpicker('refresh');
      $("[data-id='District']").prop('disabled', true);
      this.closeBtn.nativeElement.click();
      this.notificationToParent(result.data)
      $("#createNewPartnerID").modal("hide");
    } else {
      this.submitLoading = false
      Swal.fire(
        'Failed!',
        'New partner id creation failed...!',
        'error'
      )
    }

  }

  async notificationToParent(id) {
    this.createResponse.emit({ partnerID: id, status: "Done" })
  }

  async getTitle() {
    let result = await this.GetTitleService.getAllTitle()
    if (result.statusText == "Unknown Error" || result.statusCode == 500) {
      // this.ServerStatusService.notify(`SERVER-DOWN-CRITICAL check the logs and fix the issue [ Event Register API Error ] [ Get Title => API Error ]`)
      app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
    }
    this.allTitle = result.data
  }

  async getAllCSC() {
    // return await this.GetCountryStateCityService.getAll()
    return await this.GetCountryStateCityService.getAllCountry()
  }

  public pinMsg: Boolean = true
  async getSelectedCountry(val) {
    if (val == "Others") {
      this.pinMsg = false
      this.noCountryAvailable = false
      this.noStateAvailable = false
      this.noCityAvailable = false
      this.ifForeign = true
      this.mobileNoValidation = 20
    } else {
      this.pinMsg = false
      this.province = true
      this.ifForeign = true
      this.noStateAvailable = true
      this.noCityAvailable = true
      let temp = this.allCSC.filter(country => country.name == val)
      this.countryID = temp[0].id
      let result = await this.GetCountryStateCityService.getAllState(temp[0].id)
      this.tempState = result.data
      this.allState = result.data
      this.allState.push({ name: "Others" })
      setTimeout(function () {
        $(`.state`).selectpicker('refresh');
        $("[data-id='State']").prop('disabled', false);
      }, 100)

      if (val == 'India') {
        this.mobileNoValidation = 10
        this.ifForeign = false
        this.province = false
        $("#mobileNumber").val("");
        setTimeout(() => {
          $(`.district`).selectpicker('refresh');
          $("[data-id='District']").prop('disabled', true);
        }, 100)

      } else {
        this.mobileNoValidation = 20
        // this.=this.tempState[0].phone_code.includes("+") == true ? this.tempState[0].phone_code:"+"+this.tempState[0].phone_code
        $("#mobileNumber").val(temp[0].phonecode.includes("+") == true ? temp[0].phonecode : "+" + temp[0].phonecode);
        this.province = true
      }
    }
  }


  async pinCodeToGetDetails(value) {
    if (!this.ifForeign) {
      let checkValue = /\d{6}/
      this.invalidPin = false
      if (checkValue.test(value)) {
        this.pinCodeLoader = true
        let result = await this.PinCodeToGetDetailsService.getPinDetails(value)

        if (result.status == 404) {
          this.pinCodeLoader = false
          this.invalidPin = true
        } else {
          this.pinCodeLoader = false
          let selectedPin = result.data
          this.pintoPopulate.state = selectedPin[0].STATE_NAME
          this.pintoPopulate.state_id = selectedPin[0].STATE_ID
          this.pintoPopulate.district = selectedPin[0].DISTRICT_NAME

          this.getSelectedState(this.pintoPopulate.state)
          //           $("#address3").val(function() {
          //     return this.value + ','POST_OFFICE;
          // });
          // if (selectedPin.length != 1) {
          // this.allState = []
          this.allDistrict = []
          // this.allCity = []
          selectedPin.forEach(element => {
            // this.allState.push({name:element.STATE_NAME})
            this.allDistrict.push(element.DISTRICT_NAME)
          });
          // this.allState.push({name:"Others"})
          this.allDistrict.push("Others")

          setTimeout(function () {
            $(`.state`).selectpicker('refresh');
            $(`.city`).selectpicker('refresh');
            $(`.district`).selectpicker('refresh');
            $("[data-id='City']").prop('disabled', false);
            $("[data-id='District']").prop('disabled', false);
          }, 100)
        }
        // }
      }
    }

  }


  public errorEmail: Boolean = false
  public emailLoader: Boolean = false
  public errorMobile: Boolean = false
  public mobileLoader: Boolean = false
  async checkMobileNumberAndEmailAlreadyExist(type, email, mobile, name) {

    var data
    var check = false
    this.emailLoader = true
    console.log(email)
    console.log(mobile)
    console.log(await this.formEmailValidation(email))
    if (await this.formEmailValidation(email)) {
      this.errorEmail = false
      if (mobile != "") {
        check = true
        this.errorMobile = false
        console.log("asd")
      } else {
        check = false
        this.errorMobile = true
        this.emailLoader = false
        console.log("asd11")
      }
    } else {
      check = false
      this.errorEmail = true
      this.emailLoader = false
    }
    console.log(check)
    if (check) {
      data = `email_id=${email}&primary_mobile_no=${mobile}&full_name=${name}`
      await this.callMobileNumberAndEmailAlreadyExist(data, type, email)
    }

  }

  async checkMobileNumber(mobile) {
    this.mobileLoader = true
    if (await this.formMobileNumberValidation(mobile)) {
      this.errorMobile = false
      this.mobileLoader = false
    } else {
      this.errorMobile = true
      this.mobileLoader = false
    }
  }

  async callMobileNumberAndEmailAlreadyExist(data, type, val) {
    let result = await this.GetPartnerIDService.getPartnerID(data)
    this.emailLoader = false
    this.mobileLoader = false
    if (result.data.length != 0) {
      Swal.fire({
        title: 'Email ID or Mobile Number Already Exist.',
        // text: "You want to use already Exist one ..?",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        cancelButtonText: "No I want new entry",
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then((result) => {
        if (result.value) {
          // $("#createNewPartnerID").modal("hide");
          // this.notificationToParent1(data, type, val)
        }
      })
    }
  }


  async notificationToParent1(value, key, val) {
    this.createResponseAlreadyExist.emit({ value: val, status: "Done", key: key })
  }


  async getSelectedDistrict(val) {
    if (val == "Others") {
      this.noDistrictAvailable = false
    } else {
      // this.allDistrict.forEach(element => {

      //   if ($("#address3").val().includes(',')) {
      //     $("#address3").val($("#address3").val().replace("," + element.split(',')[1], ""))
      //   } else {
      //     $("#address3").val($("#address3").val().replace(element.split(',')[1], ""))
      //   } 
      // });
      //  $("#address3").val($("#address3").val() == "" ? val.split(',')[1] : $("#address3").val().trim() + " " + "," + val.split(',')[1])
    }
  }

  public cityLoader: Boolean = false
  public noCloseButtonInCity: Boolean = false
  async getSelectedState(val) {
    this.cityLoader = true
    if (val == "Others") {
      this.noStateAvailable = false
      this.noCityAvailable = false
      this.noCityAvailableCancelButton = true
    } else {
      // if(val == this.pintoPopulate.state){
      //   $("[data-id='State']").prop('disabled', true);
      // }

      this.noCityAvailable = true
      this.noCityAvailableCancelButton = false
      let temp = this.tempState.filter(ele => ele.name == val)
      this.stateID = temp[0].id
      let result = await this.GetCountryStateCityService.getAllCity(this.countryID, temp[0].id)
      if (result.data.length == 0) {
        this.noCityAvailable = false
        setTimeout(() => {
          this.cityLoader = false
          this.noCloseButtonInCity = true
        }, 90)
        setTimeout(() => {
          // $(`.city`).selectpicker('refresh');
          // $("[data-id='City']").prop('disabled', false);
          if (val == this.pintoPopulate.state) {
            $("[data-id='State']").prop('disabled', true);
          }
        }, 100)
      } else {
        this.noCloseButtonInCity = false
        this.allCity = result.data
        this.allCity.push({ name: "Others" })
        setTimeout(() => {
          this.cityLoader = false
        }, 90)
        setTimeout(() => {
          $(`.city`).selectpicker('refresh');
          $("[data-id='City']").prop('disabled', false);
          if (val == this.pintoPopulate.state) {
            $("[data-id='State']").prop('disabled', true);
          }
        }, 100)
      }

    }
  }

  async onMaritalStatus(ele, val) {
    if (val == 2) {
      this.marital.married = true
    } else {
      this.marital.married = false
    }

  }

  async getSelectedCity(val) {
    if (val == "Others") {
      this.noCityAvailable = false
    }
    let temp = this.allCity.filter(ele => ele.name == val)
    this.cityID = temp[0].id
    // this.allPin = this.allPinDistrict.filter(pin => pin.City.match(val))
    // setTimeout(function () {
    //   $(`.pinCode`).selectpicker('refresh');
    //   $("[data-id='PinCode']").prop('disabled', false);
    // }, 100)
  }

  backToSelect(val) {
    switch (val) {
      case 1:
        this.noCountryAvailable = true

        this.pinMsg = true
        this.noStateAvailable = true
        this.noCityAvailable = true
        this.ifForeign = true
        this.province = false
        setTimeout(function () {
          $(`.country`).selectpicker('refresh');
          $(`.state`).selectpicker('refresh');
          $(`.city`).selectpicker('refresh');
          $(`.district`).selectpicker('refresh');
          $("[data-id='State']").prop('disabled', true);
          $("[data-id='City']").prop('disabled', true);
          $("[data-id='District']").prop('disabled', true);
        }, 100)
        break;
      case 2:
        this.noStateAvailable = true
        setTimeout(function () {
          $(`.state`).selectpicker('refresh');
        }, 100)
        break;
      case 3:
        this.noCityAvailable = true
        setTimeout(function () {
          $(`.city`).selectpicker('refresh');
        }, 100)
      case 4:
        this.noDistrictAvailable = true
        setTimeout(function () {
          $(`.district`).selectpicker('refresh');
        }, 100)
        break;
    }
  }


  public firstName: Boolean = false
  public LastName: Boolean = false
  public Occupation: Boolean = false
  public ChurchName: Boolean = false
  public PastorAddress: Boolean = false
  public PastorName: Boolean = false
  public Denomination: Boolean = false
  public PresentMinistry: Boolean = false
  public AadharNumber: Boolean = false
  public MinistryName: Boolean = false
  async checkSplChar(key, value) {

    switch (key) {
      case 1:
        var regex = /^[A-Za-z0-9 ]+$/
        if (value.length == 0) {
          return
        }
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.firstName = true
        } else {
          this.firstName = false
        }

        break;
      case 2:
        var regex = /^[A-Za-z0-9 ]+$/
        var isValid = regex.test(value);
        if (value.length == 0) {
          return
        }
        if (!isValid && value !== '') {
          this.LastName = true
        } else {
          this.LastName = false
        }

        break;
      case 3:
        var regex = /^[A-Za-z0-9 ]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.Occupation = true
        } else {
          this.Occupation = false
        }

        break;
      case 4:
        var regex = /^[A-Za-z0-9 ]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.ChurchName = true
        } else {
          this.ChurchName = false
        }

        break;
      case 5:
        var regex = /^[A-Za-z0-9 \r\n]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.PastorAddress = true
        } else {
          this.PastorAddress = false
        }

        break;
      case 6:
        var regex = /^[A-Za-z0-9 ]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.PresentMinistry = true
        } else {
          this.PresentMinistry = false
        }
      case 7:
        var regex = /^[A-Za-z0-9 \r\n]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.PastorName = true
        } else {
          this.PastorName = false
        }
        break;
      case 8:
        var regex = /^[A-Za-z0-9 \r\n]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.Denomination = true
        } else {
          this.Denomination = false
        }
        break;
      case 9:
        var regex = /^[A-Za-z0-9 \r\n]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.MinistryName = true
        } else {
          this.MinistryName = false
        }
        break;
      case 10:
        var regex = /^[A-Za-z0-9 \r\n]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.AadharNumber = true
        } else {
          this.AadharNumber = false
        }
        break;
    }
  }

  async getLanguage() {
    let result = await this.GetAllLanguageService.getAllLanguage()
    if (result.statusText == "Unknown Error" || result.statusCode == 500) {
      // this.ServerStatusService.notify(`SERVER-DOWN-CRITICAL check the logs and fix the issue [ Event Register API Error ] [ Get All Language => API Error ]`)
      app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
    }
    this.allLanguage = result.data
  }

  async getEduction() {
    let result = await this.GetAllEducationService.getAllEducation()
    if (result.statusText == "Unknown Error" || result.statusCode == 500) {
      // this.ServerStatusService.notify(`SERVER-DOWN-CRITICAL check the logs and fix the issue [ Event Register API Error ] [ Get Eduction => API Error ]`)
      app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
    }
    this.allEduction = result.data
  }

  async formEmailValidation(elementValue) {
    if (elementValue !== '') {
      var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (emailPattern.test(elementValue)) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  async formMobileNumberValidation(elementValue) {
    var Pattern = /[0-9\+\-\ ]{10}$/;
    if (Pattern.test(elementValue)) {
      return true
    } else {
      return false
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  keyPressEvent(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode != 8 && !pattern.test(inputChar))) {
      if (event.keyCode != 13) {
        event.preventDefault();
      }
    }
  }

  reload() {
    this.pintoPopulate.state = ""
    this.createPartnerIdData.resetForm();
    $(`.title`).selectpicker('refresh');
    $(`.language`).selectpicker('refresh');
    $(`.eduction`).selectpicker('refresh');
    $(`.country`).selectpicker('refresh');
    $(`.state`).selectpicker('refresh');
    $(`.profession`).selectpicker('refresh');
    $(`.selectMinistry`).selectpicker('refresh');
    $("[data-id='State']").prop('disabled', true);
    $(`.city`).selectpicker('refresh');
    $("[data-id='City']").prop('disabled', true);
    $(`.district`).selectpicker('refresh');
    $("[data-id='District']").prop('disabled', true);
  }

}
